<template>
  <CreateSave
      :maxWidth="500"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :createData="createData"
      @onCreate="(response) => $emit('onCreateTicket', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <SuggestRevenuesOnlyAlertBalance
              v-model="ItemForm.Revenue"
              :error-messages="errors.Revenue"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Príjem"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.pricePart"
              :error-messages="errors.pricePart"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Čiastka"
              type="number"
              suffix="€"
          />
        </v-col>
      </v-row>
    </template>
  </CreateSave>
</template>

<script>
  import TicketRevenues from '@/services/ticket-revenues'

  import CreateSave from '@/components/_Part/_Modal/_Save/Create'

  import SuggestRevenuesOnlyAlertBalance from '@/components/Revenues/SuggestOnlyAlertBalance'

  export default {
    name: 'CreateTicket',
    props: [
      'ticketId'
    ],
    emits: [
      'onCreateTicket'
    ],
    components: {
      CreateSave,
      SuggestRevenuesOnlyAlertBalance
    },
    methods: {
      setTitle() {
        return 'Vytvoriť príjem'
      },
      setItemForm() {
        return {
          Revenue: null,
          pricePart: 0
        }
      },
      createData(ItemForm) {
        return TicketRevenues
          .createTicket({
            ticketId: this.ticketId,
            data: ItemForm
          })
      }
    }
  }
</script>
